import { MaintenanceForwardingSectionsProps } from "../../../../../features/forwardings/types/maintenanceForwarding.type";
import MaintenanceWorkflowForwardinCheckinEntrySection from "../../sections/CheckinEntry";
import MaintenanceWorkflowForwardinDirectiveEntrySection from "../../sections/DirectiveEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../sections/EstablishmentChoiceEntry";


const MaintenanceWorkflowForwardingCompleted = ({
  forwarding,
}: MaintenanceForwardingSectionsProps) => {
  return (
    <div className="flex-1 overflow-auto flex flex-col gap-4">
      <MaintenanceWorkflowForwardinDirectiveEntrySection
        forwarding={forwarding}
      />

      <MaintenanceWorkflowForwardinCheckinEntrySection
        forwarding={forwarding}
      />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection
        forwarding={forwarding}
      />
    </div>
  );
}

export default MaintenanceWorkflowForwardingCompleted;
